import Modal from "react-modal/lib/components/Modal";
import Loading from "../../../../components/loading";
import libForm from "../../../../util/libForm";
import { BtnSubmit } from "../../../../components/button/button-submit/button-submit";
import { BtnBack } from "../../../../components/button/button-back";
import { IndexHook } from "./hooks";
import HeaderRegister from "../../../../components/header/register";
import TextInput from "../../../../components/inputs/text";
import CheckboxInput from "../../../../components/inputs/check";

function ModalRegisterCategory({
	id_tipoproduto,
	isOpenModalRegister,
	handleCloseModalRegister,
	setCategoryData,
	categoryData,
}) {
	const {
		//hooks
		handleOnSubmit,
		handleChangeInt,

		loading,

		//context
		// isOpenModalRegister,
		// handleCloseModalRegister,

		//useForm
		register,
		handleSubmit,
		handleOnError,

		//formState
		errors,
		isSubmitting,
	} = IndexHook({
		id_tipoproduto,
		isOpenModalRegister,
		handleCloseModalRegister,
		setCategoryData,
		categoryData,
	});

	return (
		<>
			<Modal
				isOpen={isOpenModalRegister}
				onRequestClose={handleCloseModalRegister}
				overlayClassName="react-modal-overlay"
				className="modal-content-form modal-product-resize"
				shouldCloseOnOverlayClick={false}
			>
				<div className="container-forms">
					{loading ? (
						<div className="flex h-full">
							<Loading mensagem="Aguarde buscando dados no servidor..." />
						</div>
					) : (
						<form className="form" onSubmit={handleSubmit(handleOnSubmit, handleOnError)}>
							<HeaderRegister
								title="Categoria"
								subTitle="Cadastro de categorias"
								handleCloseModal={handleCloseModalRegister}
							/>
							<main>
								<div className="row">
									<TextInput
										label="Categoria"
										id="nome"
										placeholder="Categoria"
										register={register}
										errors={errors}
										onKeyDown={libForm.EnterTab}
										autoFocus={true}
										className="col-12 col-sm-12 col-lg-8"
									/>
									<TextInput
										label="Ordem"
										id="ordem"
										placeholder="Ordem Categoria"
										register={register}
										errors={errors}
										onKeyDown={libForm.EnterTab}
										onChange={handleChangeInt}
										className="col-4 col-sm-4 col-lg-6"
									/>
									<TextInput
										label="Observação"
										id="obs"
										placeholder="Obs Categoria"
										register={register}
										errors={errors}
										onKeyDown={libForm.EnterTab}
										className="col-8 col-sm-8 col-lg-6"
									/>

									<CheckboxInput
										label="Ativar Categoria"
										id="ativo"
										register={register}
										errors={errors}
										className="col-12 col-sm-6"
									/>
								</div>
							</main>

							<footer>
								<BtnBack onClick={handleCloseModalRegister} isSubmitting={isSubmitting} />
								<BtnSubmit isSubmitting={isSubmitting} />
							</footer>
						</form>
					)}
				</div>
			</Modal>
		</>
	);
}

export default ModalRegisterCategory;
